export default __webpack_public_path__ + "assets/home-8fe8f95.svg";